<template>
  <div :class="$style.wrapper">
    <iframe width="560" height="315" src="https://www.youtube.com/embed/bap1csBUJ8Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <div :class="$style.button">
      <l-button @click="() => $emit('nextStep', 3)">Продолжить</l-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'step01',
}
</script>
<style lang="scss" module>
.wrapper {
  width: 100%;
  height: 100%;

  iframe {
    width: 100%;
    height: 100%;
  }
}

.button {
  position: absolute;
  z-index: 15;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
}
</style>
